export default __webpack_public_path__ + "static/media/about.656dcb96.jpg";